<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>Dhule District Badminton Championship 2025
                    </h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"
            alt="GHRSCF" />
    </div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2><span>G H Raisoni Memorial Dhule District Badminton Championship 2025</span></h2>
        </div>
        <div class="row justify-content-between">
            <div class="col-md-7">
                <p><strong>Dates:</strong> 20th-22nd June 2025</p>
                <p><strong>Venue:</strong> At Badminton Hall, Jilla Krida Sankul, Wadi Bhokar Road, Dhule </p>
                <p><strong>Organised by: </strong>Dhule City and Taluka Badminton Association & Raisoni Foundation
                    Sports and Cultural </p>
                <h6>Events Categories:</h6>
                <ul class="list-style list-style1 ">
                    <li>1. Under-9 Boys and Girls Singles </li>
                    <li>2. Under-11 Boys and Girls Singles </li>
                    <li>3. Under-13 Boys and Girls Singles </li>
                    <li>4. Under-15 Boys and Girls Singles</li>
                    <li>5. Under-15 Boys and Girls Doubles</li>
                    <li>6. Under 17 Boys and Girls Singles</li>
                    <li>7. Under-17 Boys and Girls Doubles </li>
                    <li>8. Under-19 Boys and Girls Singles </li>
                    <li>9. Open Men's Singles and Men's Doubles </li>
                    <li>10.Open Women's Single and Women's Doubles </li>
                </ul>
            </div>
            <div class="col-md-4">
                <div class="image-effect-3">
                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/sport/upcoming-sports/dhule-badminton-champioship-25-may.jpg"
                        alt="GHRSCF" />
                </div>
            </div>
        </div>
        <div class="col-md-12">
            <div class="sec-title mt-4 text-center">
                <h2><span>Photo Gallery</span></h2>
            </div>
            <div class="lightBox--gallery">
                <ul class="list-unstyled lightgallery justify-content-center row row-cols-1 row-cols-md-4">
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nag-chess-fest/nag-chess-fest-1.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nag-chess-fest/nag-chess-fest-1.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nag-chess-fest/nag-chess-fest-1.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nag-chess-fest/nag-chess-fest-2.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nag-chess-fest/nag-chess-fest-2.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nag-chess-fest/nag-chess-fest-2.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nag-chess-fest/nag-chess-fest-3.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nag-chess-fest/nag-chess-fest-3.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nag-chess-fest/nag-chess-fest-3.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nag-chess-fest/nag-chess-fest-4.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nag-chess-fest/nag-chess-fest-4.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nag-chess-fest/nag-chess-fest-4.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nag-chess-fest/nag-chess-fest-5.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nag-chess-fest/nag-chess-fest-5.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nag-chess-fest/nag-chess-fest-5.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nag-chess-fest/nag-chess-fest-6.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nag-chess-fest/nag-chess-fest-6.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nag-chess-fest/nag-chess-fest-6.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nag-chess-fest/nag-chess-fest-7.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nag-chess-fest/nag-chess-fest-7.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nag-chess-fest/nag-chess-fest-7.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                    <!-- <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nag-chess-fest/nag-chess-fest-8.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nag-chess-fest/nag-chess-fest-8.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nag-chess-fest/nag-chess-fest-8.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li> -->
                    <li class="col"
                        data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nag-chess-fest/nag-chess-fest-9.webp"
                        data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nag-chess-fest/nag-chess-fest-9.webp">
                        <a href="Javascript:void(0);">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nag-chess-fest/nag-chess-fest-9.webp"
                                alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                            <div class="light-gallery-poster">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" />
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</section>

<section class="section section-sm result section-banner-bg-1">
    <div class="container">
        <div class="gall-ery shadow-soft">
            <div class="row">
                <div class="col-md-8">
                    <div class="widget_title inner-title gall-sys">
                        <h4>Referee Report</h4>
                    </div>
                </div>

            </div>
            <div class="row  row-cols-1 row-cols-lg-3 ">
                <div class="col">
                    <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/nag-chess-fest/new-final-rep-dhule-dis-tour-25.pdf"
                        target="blank">
                        <div class="category-icon-title shadow-inset">
                            <div class="category-title">
                                <span class="flaticon-pdf"></span>
                                <h4>Referee Report</h4>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>
